import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import {onMounted, ref} from 'vue';
import ChatModalMessage from "~/chat/vue/widget/ChatModalMessage.vue";
import ChatLoader from "~/chat/vue/misc/ChatLoader.vue";
import ChatHtmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import GetRequest from "~/ts/library/xhr/GetRequest";


const __default__ = {
    name: "EulaModalMessage"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    visible: { type: Boolean },
    agreementId: {}
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let eulaText = ref<string>();

onMounted(async () => {
    if (!eulaText.value) {
        let url = `${ConfigStore.apiHost.value}/support/eula.php?oid=${ConfigStore.siteId.value}&org=${ConfigStore.orgId.value}&body=1&agreementId=${props.agreementId}`;
        eulaText.value = (await (new GetRequest(url)).send()).getRawResponse();
    }
});


return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createBlock(ChatModalMessage, {
        key: 0,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:visible', $event))),
        visible: _ctx.visible,
        title: "Правила"
      }, {
        default: _withCtx(() => [
          (!_unref(eulaText))
            ? (_openBlock(), _createBlock(ChatLoader, { key: 0 }))
            : (_openBlock(), _createBlock(ChatHtmlify, {
                key: 1,
                escape: false,
                value: _unref(eulaText)
              }, null, 8, ["value"]))
        ]),
        _: 1
      }, 8, ["visible"]))
    : _createCommentVNode("", true)
}
}

})